"use strict";
/********************************************************************************
  HxTimeRangeHelpers.ts
  Copyright (c) Microsoft Corporation. All rights reserved.
********************************************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
exports.areEqualTimeRanges = exports.areOverlappingTimeRanges = void 0;
var areOverlappingTimeRanges = function (timeRange1, timeRange2) {
    return timeRange1.start < timeRange2.end && timeRange2.start < timeRange1.end;
};
exports.areOverlappingTimeRanges = areOverlappingTimeRanges;
var areEqualTimeRanges = function (timeRange1, timeRange2) {
    return timeRange1.start.valueOf() === timeRange2.start.valueOf() && timeRange1.end.valueOf() === timeRange2.end.valueOf();
};
exports.areEqualTimeRanges = areEqualTimeRanges;
